import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosInstance } from 'axios';
import { ApiKeyState, ApiKeyEntity } from './types';
import { DataPayload, SortPayloadAction } from '../types';
import ApiKeysApi from '../../api/apiKeysApi';

const initialState: ApiKeyState = {
  data: [],
  currentPage: 0,
  resultsPerPage: 8,
  totalPages: 1,
  sortColumn: 'createdAt',
  sortDirection: -1,
  selectedFilters: {},
};

const apiKeysSlice = createSlice({
  name: 'apiKeys',
  initialState,
  reducers: {
    setApiKeys: (
      state,
      { payload }: PayloadAction<DataPayload<ApiKeyEntity>>
    ) => {
      state.data = payload.entities;
      state.totalPages = payload.totalPages;
    },
    sortApiKeys: (state, { payload }: SortPayloadAction<ApiKeyEntity>) => {
      state.sortColumn = payload.column;
      state.sortDirection = payload.direction;
      state.currentPage = initialState.currentPage;
      state.data = initialState.data;
    },
    setCurrentPage: (state, { payload }: PayloadAction<number>) => {
      state.currentPage = payload;
    },
    resetApiKeyState: () => initialState,
  },
});

export const loadApiKeys = async (axios: AxiosInstance, companyId?: string) => {
  if (!companyId) {
    return setApiKeys({ entities: [], totalPages: 0 });
  }
  return setApiKeys(await ApiKeysApi.getApiKeys(axios, companyId));
};

export const { setApiKeys, sortApiKeys, setCurrentPage, resetApiKeyState } =
  apiKeysSlice.actions;

export default apiKeysSlice.reducer;
